var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMute(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 37.042 37.042",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0,
    stroke: "#fff",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.6873 23.057v-9.0726h6.2842l6.0133-3.4716v15.996l-6.0133-3.4518z",
    strokeLinecap: "round",
    strokeWidth: 1.3229
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.288 18.521a17.767 17.767 0 0 1-17.767 17.767 17.767 17.767 0 0 1-17.767-17.767 17.767 17.767 0 0 1 17.767-17.767 17.767 17.767 0 0 1 17.767 17.767z",
    strokeWidth: 1.5079
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.911 14.224 8.5744 8.5744z",
    strokeLinecap: "round",
    strokeWidth: 1.3229
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.485 14.224-8.5744 8.5744z",
    strokeLinecap: "round",
    strokeWidth: 1.3229
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/mute.6d54b1d0fe1f86bdcb4ff93a22c39eda.svg";
export { ForwardRef as ReactComponent };